import React from "react";
import { useQuery, useMutation } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Nav from "../../../components/Nav";
import { GET_ME, GET_PLEDGE_BY_PERIOD } from "../gql/queries";
import { UPDATE_PLEDGE_STATUS } from "../gql/mutations";
import Auth from "../../../utils/auth";
import "./Takhmeen.css";

const Takhmeen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { data: meData } = useQuery(GET_ME);
    const userId = meData?.me?.userId;

    const { data: previousYearData, loading: loadingPrevious } = useQuery(GET_PLEDGE_BY_PERIOD, {
        variables: { userId: userId, period: "1446-47" },
        skip: !userId,
    });

    const { data: currentYearData, loading: loadingCurrent } = useQuery(GET_PLEDGE_BY_PERIOD, {
        variables: { userId: userId, period: "1447-48" },
        skip: !userId,
    });

    const [updatePledgeStatus] = useMutation(UPDATE_PLEDGE_STATUS, {
        refetchQueries: [{ query: GET_ME }],
    });

    const previousYearPledge = previousYearData?.getPledgeByPeriod;
    const currentYearPledge = currentYearData?.getPledgeByPeriod;

    const handleAccept = async () => {
        try {
            await updatePledgeStatus({
                variables: {
                    pledgeId: currentYearPledge._id,
                    status: "ACCEPTED",
                },
            });
            const referrer = location.state?.referrer || Auth.getReferrer() || "/openMenus";
            window.location.assign(referrer);
        } catch (err) {
            console.error("Error updating pledge status:", err);
        }
    };

    const handleDecline = async () => {
        try {
            await updatePledgeStatus({
                variables: {
                    pledgeId: currentYearPledge._id,
                    status: "DECLINED",
                },
            });
            const referrer = location.state?.referrer || Auth.getReferrer() || "/openMenus";
            window.location.assign(referrer);
        } catch (err) {
            console.error("Error updating pledge status:", err);
        }
    };

    if (loadingPrevious || loadingCurrent) {
        return (
            <>
                <div className="navAndHeader">
                    <Nav />
                </div>
                <div className="mainContainer">
                    <p>Loading...</p>
                </div>
            </>
        );
    }

    if (!previousYearPledge || !currentYearPledge) {
        return <Navigate to="/openMenus" replace />;
    }

    if (currentYearPledge.status !== "PENDING") {
        return <Navigate to="/openMenus" replace />;
    }

    const previousAmount = previousYearPledge.amount || 0;
    const currentAmount = currentYearPledge.amount || 0;
    const percentage = previousAmount === 0 ? 100 : (previousAmount > 0 
        ? ((currentAmount - previousAmount) / previousAmount) * 100 
        : 0);

    const getFirstClarification = (percentage) => {
        if (percentage === 0) {
            return "We are requesting the same participation amount as last year";
        } else if (percentage <= 10) {
            const formattedPercentage = percentage % 1 === 0 
                ? percentage.toString() 
                : percentage.toFixed(2).replace(/\.?0+$/, '');
            return (
                <>
                    The <span className="takhmeenPercentage">{formattedPercentage}%</span> increase will help offset the increase in costs we are facing due to inflation over the last year
                </>
            );
        } else {
            return "We are requesting an increase in participation so we can maintain the FMB program in Austin";
        }
    };

    return (
        <>
            <div className="navAndHeader">
                <Nav />
            </div>
            <div className="mainContainer">
                <h1>Takhmeen</h1>
                <div className="takhmeenTile">
                    <div className="takhmeenText">
                        <p>
                            Your takhmeen (pledge) for <span className="takhmeenYearRed">1446H-1447H (Mar '25 - Feb '26)</span>
                            <span className="takhmeenAmount">${previousAmount}</span>
                            Takhmeen requested for <span className="takhmeenYearRed">1447H-1448H (Mar '26 - Feb '27)</span>
                            <span className="takhmeenAmount">${currentAmount}</span>
                        </p>
                        <ul className="takhmeenClarifications">
                            <li>If you have a niyyat to pledge more than the requested amount, please contact Janaab Amil Saheb or the FMB team</li>
                            <li>{getFirstClarification(percentage)}</li>
                            <li>Mumineen will Adaa this amount starting February 2026</li>
                            <li>You can defer to an in-person takhmeen, but Takhmeen must be completed <span className="takhmeenYearRed">before Shehrullah 1447H (Jan 30 2026)</span>, contact the FMB team for any questions</li>
                        </ul>
                    </div>
                    <div className="takhmeenButtonContainer">
                        <button
                            onClick={handleAccept}
                            className="takhmeenAgreeButton"
                        >
                            Accept
                        </button>
                        <button
                            onClick={handleDecline}
                            className="takhmeenDeclineButton"
                        >
                            Defer
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Takhmeen;

